module.exports = __webpack_public_path__ + "static/media/IMG_0649_2.d7993a6d.jpg";